import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import { Checkbox } from 'antd';
import isURL from 'validator/lib/isURL';
import $j from 'jquery';

import Icon from '../../../../../../../helper/Icon';
import { validateIframeRegex } from '../../../../../../../helper/validators';

const styles = getStyles(); // eslint-disable-line no-use-before-define

class EmbedSettings extends Component {
  static contextTypes = {
    dispatch: PropTypes.func
  };

  constructor(props) {
    super(props);

    const showRaw = this.getIsRaw();

    this.state = {
      inEditMode: false,
      processingMedia: false,
      errorMsg: null,
      showRaw
    };

    if (props.blockItem.items[0].media.embed.src) {
      this.state.inEditMode = false;
    } else {
      this.state.inEditMode = true;
    }
  }

  onShowRawChange = () => {
    this.setState({ showRaw: !this.state.showRaw });
  };

  onHideMetadataChange = (e) => {
    const src = this.props.blockItem.items[0].media.embed.src;
    let srcJson = {};
    try {
      srcJson = JSON.parse(src);
    } catch (error) {
      console.log(error);
    }
    srcJson.hideMetadata = e.target.checked;
    this.inputEmbedChange(this.props.blockItem)(JSON.stringify(srcJson), 'embedly');
  };

  onInputKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      const inputValid = this.validateInputText(e.target.value);
      if (inputValid.valid) {
        if (inputValid.type === 'iframe') {
          this.inputEmbedChange(this.props.blockItem)(e.target.value, 'iframe');
          this.setState({
            inEditMode: false
          });
        } else if (inputValid.type === 'url') {
          if (this.state.showRaw) {
            this.inputEmbedChange(this.props.blockItem)(e.target.value, 'url');
            this.setState({
              inEditMode: false
            });
          } else {
            this.getEmbedlyResponse(e.target.value);
          }
        }
      } else {
        this.setState({
          errorMsg: 'Please enter a valid URL or iframe'
        });
      }
    }
  };

  getEmbedlyResponse = (url) => {
    this.setState({
      processingMedia: true
    });
    $j.getJSON(
      'https://api.embedly.com/1/oembed?'
        + $j.param({
          url,
          key: '40fe86ee3b404724858baae1d097c574'
        })
    )
      .done((data) => {
        if (!data.url) {
          const dataToBeSent = {
            userInput: url,
            embedlyData: data
          };
          this.inputEmbedChange(this.props.blockItem)(JSON.stringify(dataToBeSent), 'richContent');
        } else {
          this.inputEmbedChange(this.props.blockItem)(JSON.stringify(data), 'embedly');
        }
        this.setState({
          processingMedia: false,
          inEditMode: false
        });
      })
      .fail(() => {
        this.setState({
          processingMedia: false,
          inEditMode: false
        });
      });
  };

  getIsRaw = () => {
    const embedType = this.props.blockItem.items[0].media.embed.type;
    return embedType === 'url';
  };

  validateInputText = (text) => {
    if (validateIframeRegex.test(text)) {
      return {
        valid: true,
        type: 'iframe'
      };
    }
    if (isURL(text)) {
      return {
        valid: true,
        type: 'url'
      };
    }
    return {
      valid: false
    };
  };

  handleOnChange = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      this.setState({
        errorMsg: null
      });
    } else {
      this.setState({
        errorMsg: null
      });
    }
  };

  inputEmbedChange = blockItem => (embedText, embedType) => {
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      media: {
        embed: {
          src: embedText,
          type: embedType
        }
      }
    });
  };

  changeMode = mode => () => {
    if (mode === 'edit') {
      this.setState({
        inEditMode: true
      });
    } else if (mode === 'preview') {
      this.setState({
        inEditMode: false
      });
    }
  };

  renderThumbImage = (thumbURL, imgSrc, link) => {
    if (thumbURL) {
      return <img className="block-edit-field-image__image" src={imgSrc} alt="" />;
    }
    return (
      <a className="embedImage__Link" href={link} target="_blank">
        <img className="block-edit-field-image__image" src={imgSrc} alt="" />
      </a>
    );
  };

  renderPreview = (src, type) => {
    if (type === 'embedly' || type === 'richContent') {
      const srcJson = JSON.parse(src);
      const imageSrc = srcJson.thumbnail_url
        ? srcJson.thumbnail_url
        : 'https://dndw32r4edmw5.cloudfront.net/lyearn/assets/embed_thumb_image.png';
      const actualURL = type === 'embedly' ? srcJson.url : srcJson.userInput;
      return (
        <div className="block-edit-audio">
          <div>
            <div className="block-edit-field-image__row">
              <div className="block-edit-field-image__image-container">
                {this.renderThumbImage(srcJson.thumbnail_url, imageSrc, actualURL)}
              </div>
              <div className="block-edit-field-image__filename block-edit-field-image__filename--embed block-edit-field-image__filename--display">
                <div style={{ wordWrap: 'break-word' }}>{actualURL}</div>
              </div>
              <div className="block-edit-field-image__actions">
                <span
                  className="block-edit-field-image__actions-link"
                  onClick={this.changeMode('edit')}
                >
                  Change
                </span>
              </div>
            </div>
          </div>
          {!this.state.errorMsg && type === 'embedly' ? (
            <div className="marginBottom10">
              <Checkbox defaultChecked={srcJson.hideMetadata} onChange={this.onHideMetadataChange}>
                Hide Metadata
              </Checkbox>
            </div>
          ) : null}
        </div>
      );
    }
    if (type === 'iframe' || type === 'url') {
      return (
        <div className="block-edit-audio">
          <div>
            <div className="block-edit-field-image__row">
              <div className="embed--url_block">
                <div style={styles.rawSourceStyle}>{src}</div>
                {type === 'url' && (
                  <div className="embed--url_checkBox">
                    <Checkbox checked={true} disabled={true}>
                      Show raw
                    </Checkbox>
                  </div>
                )}
              </div>
              <div className="block-edit-field-image__actions">
                <span
                  className="block-edit-field-image__actions-link"
                  onClick={this.changeMode('edit')}
                >
                  Change
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return <div>Unable to generate preview</div>;
  };

  renderProcessing = () => (
    <div className="upload">
      <strong className="upload__text">Processing media...</strong>
      <div className="upload__processing" />
    </div>
  );

  renderEditMode = (src, type) => {
    let actualURL = '';
    let showRaw = false;
    switch (type) {
      case 'embedly':
        actualURL = JSON.parse(src).url;
        break;
      case 'richContent':
        actualURL = JSON.parse(src).userInput;
        break;
      case 'iframe':
        actualURL = src;
        break;
      case 'url':
        actualURL = src;
        showRaw = true;
        break;
      default:
        break;
    }
    return (
      <div className="block-edit-field-embed">
        {!this.state.errorMsg && (
          <div className="marginBottom10">
            <Checkbox defaultChecked={showRaw} onChange={this.onShowRawChange}>
              Show raw
            </Checkbox>
          </div>
        )}
        <div>
          <button className="item-media__dismiss" onClick={this.changeMode('preview')}>
            <Icon style={{ float: 'left' }} icon="close" size="12px" fill="#000" />
          </button>
          <div className="item-media__row item-media__row--dark">
            <input
              type="text"
              defaultValue={actualURL}
              className="item-media__input"
              placeholder="Paste URL or iframe code here ..."
              onChange={this.handleOnChange}
              onKeyDown={this.onInputKeyDown}
            />
          </div>
          <div className="item-media__footer">
            {!!this.state.errorMsg && (
              <span className="item-media__error">{this.state.errorMsg}</span>
            )}
            {!this.state.errorMsg && (
              <span className="item-media__embedTip">Enter to create embed</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const embedText = this.props.blockItem.items[0].media.embed.src;
    const embedType = this.props.blockItem.items[0].media.embed.type;
    return (
      <div className="EmbedSettingsContainer">
        <div className="block-edit__content padding0">
          {!this.state.processingMedia
            && !this.state.inEditMode
            && embedText
            && this.renderPreview(embedText, embedType)}
          {this.state.processingMedia && this.renderProcessing()}
          {!this.state.processingMedia
            && this.state.inEditMode
            && this.renderEditMode(embedText, embedType)}
        </div>
        <Style rules={styles.classBased} scopeSelector=".EmbedSettingsContainer" />
      </div>
    );
  }
}

function getStyles() {
  return {
    classBased: {
      '.padding0': {
        padding: 0
      },
      '.checkbox__label:before': {
        display: 'none'
      },
      '.checkbox-label': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      '.checkbox__label': {
        width: 'auto'
      },
      '.showMetadataInput': {
        marginRight: '5px'
      },
      '.embedImage__Link': {
        cursor: 'pointer'
      },
      '.marginBottom10': {
        marginBottom: '10px'
      }
    },
    rawSourceStyle: {
      wordBreak: 'break-word'
    }
  };
}

export default EmbedSettings;
